import EnrollmentTable from '@activities/components/tables/enrollment-table/enrollment-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-enrollments',
  components: {
    'bpc-enrollment-table': EnrollmentTable,
  },
})
export default class ProfileEnrollments extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
